/** 三端登录校验
 * 登录成功，会自动执行需要登录后刷新的操作，如产品库相关页面会请求产品当前项目信息；
 * 插件登录成功后，会将token存起来，以模拟插件端调用后端接口；
 * **/
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { checkExistFile, readUserToFile, writeUserToFile, loginCachePath, deleteFile } from '@/core/desktopCache'

export default {
  data () {
    return {
      cacheFileName: ''
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      user: 'user/user',
      userToken: 'user/userToken',
      localAppData: 'localAppData',
    }),
    ignoreLogin() {
      return !!(this.$route.meta && this.$route.meta.ignoreLogin)
    },
  },
  methods: {
    ...mapMutations({
      setShowRLoginButton: 'setShowRLoginButton',
      setUserToken: 'user/setUserToken',

    }),
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
    }),
    // 三端判断用户是否登录的公共方法
    async checkLogin(inToken) {
      if (this.platform === 'r' || this.platform === 'g') {
        try {
          if (inToken) {
            return await this.loginWriteUserToFile(inToken)
          } else {
            if (await checkExistFile(loginCachePath()) === true) {
              const fileContext = await readUserToFile()
              if (fileContext && fileContext !== false) {
                const { isLogin, token } = JSON.parse(fileContext)
                // 如果登录了，就将token存起来
                if (isLogin && token) {
                  await this.loadUserInfo({ Authorization: `Bearer ${token}` })
                  if (this.user && this.user.id) {
                    this.setUserToken(token)
                    return true
                  } else {
                    this.setUserToken(null)
                    await deleteFile(loginCachePath())
                    if (['AppGbr', 'AppGroad'].includes(this.softwareCode)) {
                      // 获取软件本身的登录信息
                      return await this.useSoftwareLogin()
                    } else {
                      return false
                    }
                  }
                } else {
                  this.setUserToken(null)
                  await deleteFile(loginCachePath())
                  if (['AppGbr', 'AppGroad'].includes(this.softwareCode)) {
                  // 获取软件本身的登录信息
                    return await this.useSoftwareLogin()
                  } else {
                    return false
                  }
                }
              }
            } else if (['AppGbr', 'AppGroad'].includes(this.softwareCode)) {
              // 获取软件本身的登录信息
              return await this.useSoftwareLogin()
            }
          }
        } catch (error) {
          console.error(error)
          return false
        }
      } else {
        // web端
        try {
          await this.loadUserInfo()
          this.setUserToken(null)
          return !!this.user.strId
        } catch (err) {
          return false
        }
      }
    },
    async useSoftwareLogin() {
      try {
        const isActiveLogout = sessionStorage.getItem('isActiveLogout')
        if (isActiveLogout) { return false }
        const data = await this.$desktopClient.GetUserInfo()
        if (data.code === 'success' && data.data.accessToken) {
          const gToken = data.data.accessToken
          await this.loadUserInfo({ Authorization: `Bearer ${gToken}` })
          if (this.user && this.user.id) {
            this.setUserToken(gToken)
            return true
          } else {
            this.setUserToken(null)
            return false
          }
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    },
    async loginWriteUserToFile(token) {
      await this.loadUserInfo({ Authorization: `Bearer ${token}` })
      if (this.user && this.user.id) {
        writeUserToFile({ isLogin: true, token: token, ...this.user }).catch()
        this.setUserToken(token)
        return true
      } else {
        this.setUserToken(null)
      }
      return false
    },
  }
}
